var path = 'msi/toasts/container/toast-container.html';
var html = "<div class=\"og-toast-container\" role=\"alert\" aria-live=\"assertive\" aria-atomic=\"true\">\n  <og-toast og-for=\"toast\" ng-repeat=\"toast in $ctrl.toastService.toasts\"></og-toast>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;